import config from "configs/config";
import apiClient from "lib/api-client";

export const revertSingleData = async (syncId) => {
  let response = await apiClient.post(`${config.baseUrl}/api/v1/sync/revertSingleDyanamicSyncData`, { syncId });
  return response.data;
};
